module.exports = __webpack_public_path__ + "img/periodic_harsh_brk.ce0bd332.png";